var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothingFootwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.313 18.22c-38.374 0-65.98 2.768-85.032 8.5-19.05 5.73-29.247 13.7-35.874 25.468-12.14 21.562-10.572 61.474-8.375 120.593 19.884-8.89 47.444-11.333 78.19-10.905 35.384.493 74.694 5.72 109.31 14.375 18.682-46.793 28.3-91.058 38-135.344.553 43.798.98 87.61-9.655 131.406 26.36 9.144 45.587 23.717 56.53 39.438 11.877-31.154 20.094-58.353 23.626-81.094 4.292-27.623 1.972-48.605-6.874-64.406-8.846-15.8-24.57-27.567-50.656-35.75-26.087-8.183-62.19-12.28-109.188-12.28zM171.97 180.53c-9.123.087-17.842.61-25.94 1.47-9.856 77.77-11.774 156.56-4.468 254.563 26.544 23.08 66.735 31.19 105.47 40.906-32.55 1.308-65.25.195-98.5-9.595 8.33 17.868 23.528 25.03 44 25.03H450.5c37.102 0 22.515-40.208 3.094-66.936-22.223-30.585-65.654-34.498-101.22-58.533l.126.22c-38.968-15.458-77.94.41-116.906 31.562 20.12-29.928 48.293-56.017 80.187-56.47 3.742-.053 7.544.276 11.376.97-3.076-8.267-5.614-16.393-7.656-24.376-33.092-22.49-73.682-16.99-118 2.5 22.384-19.514 49.346-35.1 75.438-35.625 13.233-.267 26.238 3.352 38.312 12.28-5.426-35.452-1.14-68.74 9.438-102.47-4.554-2.32-9.476-4.46-14.782-6.31l-12.375-2.126-2.717 9.656c-35.354-9.928-78.42-16.166-115.875-16.688-2.34-.032-4.674-.052-6.97-.03z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothingFootwear);
export default __webpack_public_path__ + "static/media/clothing-footwear.aaa2a47dee3444a1041a6ea5ed8f3197.svg";
export { ForwardRef as ReactComponent };